import { ChangeDetectionStrategy, Component, Input, OnInit } from "@angular/core";

/**
 * Component for showing progress and direction as a label
 * @example <progress-indicator-label deltaPercentage="[1.32]" [lessIsBetter]="true" [isAccent]="true"></progress-indicator-label>
 * */

@Component({
  selector: "progress-indicator-label",
  templateUrl: "./progress-indicator-label.component.html",
  styleUrls: ["./progress-indicator-label.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    "[class.success]": `(lessIsBetter && deltaPercentage < 0) || (!lessIsBetter && deltaPercentage > 0)`,
    "[class.danger]": `(lessIsBetter && deltaPercentage > 0) || (!lessIsBetter && deltaPercentage < 0)`,
    "[class.neutral]": `deltaPercentage === 0`,
    "[class.accent]": `isAccent`,
  },
})
export class ProgressIndicatorLabelComponent implements OnInit {
  /**
   * @param deltaPercentage the delta percentage(as a number) to be transformed into percentage
   */
  @Input() public deltaPercentage: number;
  /**
   * @param lessIsBetter whether are tracking a target that should decrease; defaults to false
   */
  @Input() public lessIsBetter = false;
  /**
   * @param isAccent whether there is background of the label
   */
  @Input() public isAccent: boolean;

  public iconType: "up" | "down" | null;

  public ngOnInit(): void {
    this.iconType = this.getIconType();
  }

  private getIconType(): typeof this.iconType {
    if (this.deltaPercentage > 0) {
      return "up";
    }

    if (this.deltaPercentage < 0) {
      return "down";
    }

    return null;
  }
}
